module.exports = __webpack_public_path__ + "static/img/validada.fc184956.png";